import { render, staticRenderFns } from "./LentiSole.vue?vue&type=template&id=c3956f5e&"
import script from "./LentiSole.vue?vue&type=script&lang=js&"
export * from "./LentiSole.vue?vue&type=script&lang=js&"
import style0 from "./LentiSole.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports